.enabledButton {
    border: 1px solid var(--mantine-color-dark-0);
}

.disabledButton {
    border: none;
    color: #d5d6da61;
}
